export const SET_COPIED_LINE_ITEMS = 'SET_COPIED_LINE_ITEMS';
export const CLEAR_COPIED_LINE_ITEMS = 'CLEAR_COPIED_LINE_ITEMS';

export const setCopiedLineItems = lineItems => ({
  type: SET_COPIED_LINE_ITEMS,
  payload: {
    lineItems,
  },
});

export const clearCopiedLineItems = () => ({
  type: CLEAR_COPIED_LINE_ITEMS,
});
